import React,{ useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card, Button, ButtonToolbar, ButtonGroup, Alert, Row, Col, Spinner } from 'react-bootstrap';
import { Animated } from "react-animated-css";
import { Form as FinalForm } from 'react-final-form';
import { withRouter } from "react-router-dom";

import { Printer } from '@styled-icons/boxicons-regular/Printer';
import { Delete } from '@styled-icons/feather/Delete';
import { EmojiSad } from '@styled-icons/entypo/EmojiSad';
import { EmojiSmile } from '@styled-icons/bootstrap/EmojiSmile';
import { PrintAdd } from '@styled-icons/fluentui-system-regular/PrintAdd';
import { CheckCircle } from '@styled-icons/boxicons-regular/CheckCircle';

import { credencialTodosPedidosPdfBlob, pesquisa as pesquisacredencial } from '../../../actions/credenciamento/credencial';

import { getDecodeEvento, setLogoutusercred } from '../../../utils/eventosessioncred';

const Credenciais = (props) => {

    const [evento, setEvento] = useState({});
    const [cpfTeclado, setCpf] = useState('');
    const [credencial_bto_pdf, setCredencialPdf] = useState(null);
    const [printok, setPrintOk] = useState(false);    
    const [credencialpesquisa, setCredencialPesquisa] = useState(null);
    
    const css = {padding: "70px", fontSize: "50px", width: "209px", height: "90px"};

    const load = async () => {
        setEvento(await getDecodeEvento(props, 'imagemevento')); 
    }
    

    const handleTeclado = (numero, form) => {
        let n = `${cpfTeclado}`;
        n += `${numero}`;
        setCpf(n);
        if(n.length===11){
            setTimeout(() => {
                form.submit();
            },500);
        }
    }

    const handleDelete = () => {
        setCredencialPesquisa(null);	
        setCpf(cpfTeclado.substring(0, cpfTeclado.length - 1));
    }

    const handleDeleteTudo = () => {
        setCredencialPesquisa(null);
        setCpf('');
    }
    
    const handleSubmit = async () => {
        setLogoutusercred();
        const credencial = await props.pesquisacredencial({idpromotora: evento.idpromotora, idevento: evento.idevento, cpf: cpfTeclado});
        if(credencial&&credencial.idcredencial){
            const pdf_code = await props.credencialTodosPedidosPdfBlob({
                idpromotora: evento.idpromotora,
                idevento: evento.idevento,
                linguagem: 'pt',
                aplicacao: 'credenciamento',
                idcredencial: Buffer.from(`${credencial.idcredencial}`).toString('base64')
            });
            
            const file = new Blob([pdf_code],{type: 'application/pdf'});//Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            setCredencialPdf(fileURL);
            setCredencialPesquisa(credencial);
            onDocumentLoadSuccess();
        }else{
            setCredencialPesquisa({});
        }
    }
    
    const onDocumentLoadSuccess = () => {
        setTimeout(() => {
            setCpf('');
            setCredencialPesquisa(null);
            setPrintOk(true);
            setTimeout(() => {
                setPrintOk(false);
                setCredencialPdf(null);
            }, 8000);
        }, 15000);
    }
    
    useEffect(() => {
        setLogoutusercred();
        load();
    },[]);

    useEffect(() => {
        setLogoutusercred();
    },[props.pendingTasks]);
    
    return (
        <FinalForm
        onSubmit={handleSubmit}
        render={({form, handleSubmit, submitting}) => {
            
            return (            
                <Card.Body>        
                    
                    <form onSubmit={handleSubmit}>
                        <Alert variant={credencialpesquisa===null?"info":credencialpesquisa&&credencialpesquisa.idcredencial?"success":"warning"} style={{fontSize: "80px"}}>
                            <Alert.Heading>CPF</Alert.Heading>
                            <hr />
                            <p className="mb-0" style={{height: '100px'}}>
                                {cpfTeclado}
                            </p>
                            <p className="mb-0" style={{height: '100px', fontSize: "30px"}}>
                                {credencialpesquisa===null?
                                    null:
                                    (credencialpesquisa&&credencialpesquisa.idcredencial?
                                        <>Bem Vindo(a) {credencialpesquisa.fisica.nome+' '+credencialpesquisa.fisica.sobrenome} <EmojiSmile size="2em" /></>:
                                        <>CREDENCIAL NÃO ENCONTRADA <EmojiSad size="2em" /></>
                                    )
                                }                                
                            </p>
                        </Alert>
                        <Row>
                            <Col>
                                <ButtonToolbar className="mb-2">
                                    <ButtonGroup className="me-2" size="lg">
                                    <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(1,form)} style={css} variant="secondary" className="mr-2">1</Button>
                                    <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(2,form)} style={css} variant="secondary" className="mr-2">2</Button>
                                    <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(3,form)} style={css} variant="secondary">3</Button>
                                    </ButtonGroup>
                                </ButtonToolbar>

                                <ButtonToolbar className="mb-2">
                                    <ButtonGroup className="me-2" size="lg">
                                    <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(4,form)} style={css} variant="secondary" className="mr-2">4</Button>
                                    <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(5,form)} style={css} variant="secondary" className="mr-2">5</Button>
                                    <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(6,form)} style={css} variant="secondary">6</Button>
                                    </ButtonGroup>
                                </ButtonToolbar>

                                <ButtonToolbar className="mb-2">
                                    <ButtonGroup className='me-2' size="lg">
                                    <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(7,form)} style={css} variant="secondary" className="mr-2">7</Button>
                                    <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(8,form)} style={css} variant="secondary" className="mr-2">8</Button>
                                    <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(9,form)} style={css} variant="secondary">9</Button>
                                    </ButtonGroup>
                                </ButtonToolbar>

                                <ButtonToolbar className="mb-3">
                                    <ButtonGroup className='me-2' size="lg">
                                        <Button disabled={cpfTeclado.length===11?true:false} onClick={() => handleTeclado(0,form)} style={css} variant="secondary" className="mr-2">0</Button>
                                        <Button disabled={cpfTeclado.length>0?false:true} onClick={handleDelete} style={css} variant="danger" className="mr-2"><Delete size="1em" /></Button>
                                        <Button type="submit" disabled={cpfTeclado.length!==11?true:false} style={css} variant="info">
                                            {submitting?<Spinner animation="border" />:<Printer size="1em" />}
                                        </Button>
                                    </ButtonGroup>
                                </ButtonToolbar>
                                
                                <Button block size="lg" disabled={cpfTeclado.length>0?false:true} onClick={handleDeleteTudo} variant="danger">NOVO CPF</Button>
                                   
                            </Col>                                                        
                            <Col className="text-center">
                                {credencialpesquisa===null?
                                    null:
                                    (credencialpesquisa&&credencialpesquisa.idcredencial?
                                    <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} animationInDuration={2000}>
                                        <Alert variant="success">
                                            <strong style={{fontSize: "50px"}}>Impressão em andamento...</strong>
                                            <PrintAdd size="20em" />
                                        </Alert>
                                    </Animated>
                                    :
                                    null
                                    )
                                }
                                {printok===true?
                                <Alert variant="info"><strong style={{fontSize: "50px"}}>Impressão Finalizada!</strong><CheckCircle size="20em" /></Alert>
                                :
                                null}
                            </Col>
                        </Row>                        
                    </form>
                    {credencial_bto_pdf!==null?
                    <div style={{height: "2px", opacity: "1%"}}>
                        <iframe  src={credencial_bto_pdf} id="Pdf1" name="Pdf1"></iframe>
                    </div>
                    :
                    null
                    }
                </Card.Body>                
            );
        }}
        />
    );
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks
    }
}

export default connect(mapStateToProps,{credencialTodosPedidosPdfBlob, pesquisacredencial})(withRouter(Credenciais));